module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"plan":"Ваш Тариф","plans":"Тарифы и квоты","history":"История пополнений","info":"Платежная информация","trial":"Пробный период","transaction":"Транзакции","payments":"Оплаты","loyaltyProgram":"Программа лояльности"}}')
  delete Component.options._Ctor
}
